'use strict';

angular.module('atex.dam').directive('listValue', [ '$compile', function($compile) {
  return {
    restrict : 'E',
    replace : true,
    transclude : true,
    template : '',
    link : function(scope, element, attrs) {
      var key = '';
      key = attrs.fieldName;
      var row = scope.entry._data.aspects.contentData.data[key];
      var limitTo = attrs.limitTo;
      if (limitTo <= 0) {
        limitTo = 150;
      }
      var label = '';
      if (attrs.withLabel && row) {
        label = "<strong>" + attrs.localeLabel + ": </strong>";
      }
      if (row) {
        var field = "entry._data.aspects.contentData.data." + key;
        element.prepend(label + "<span ng-bind-html=\"to_trusted(" + field + ", " + limitTo + ")\"></span>");
        $compile(element.contents())(scope);
      }

      function capitaliseFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
    }
  };
} ]);
